module.exports = __webpack_public_path__ + "img/hr-rock-medium-09.6bedd42b.png";